

export const ENVIRONMENT: "production" | "development" =  process.env.APP_ENV as any;